import { render, staticRenderFns } from "./EditSidebar.vue?vue&type=template&id=581304a8&"
import script from "./EditSidebar.vue?vue&type=script&lang=js&"
export * from "./EditSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581304a8')) {
      api.createRecord('581304a8', component.options)
    } else {
      api.reload('581304a8', component.options)
    }
    module.hot.accept("./EditSidebar.vue?vue&type=template&id=581304a8&", function () {
      api.rerender('581304a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EditSidebar.vue"
export default component.exports